// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"22":"datenschutz","42":"impressum"}[chunkId] || chunkId) + "." + {"22":"8acbee9e","42":"04d781ed","829":"455032e6"}[chunkId] + ".css";
};